// extracted by mini-css-extract-plugin
export default {"menu":"WizardHeaderMenu_menu__uME6y"};